import PropTypes from 'prop-types';
import React from 'react';
import {connect} from 'react-redux';
import _ from 'underscore';

import FileBrowserActions from 'file-browser/FileBrowserActions';
import {EntrySummary} from 'notebook/ELNConstants';
import {BenchlingState} from 'redux-stores/reduceApp';
import * as Headers from 'ui-library/Headers';
import {WorkflowSelector} from 'workflows/reduceWorkflows';
import * as WorkflowActions from 'workflows/WorkflowActions';
import {WorkflowSummary} from 'workflows/WorkflowConstants';

interface ConnectedProps {
  entrySummaries: Array<EntrySummary> | null;
  workflowSummaries: Array<WorkflowSummary> | null;
}

export function FulfillmentLinks({entrySummaries, workflowSummaries}: ConnectedProps): JSX.Element | null {
  if (!entrySummaries || !workflowSummaries) {
    return null;
  }

  return (
    <div>
      {workflowSummaries.length > 0 && (
        <div className="u-spacing-top">
          <Headers.Title>Workflows</Headers.Title>
          <div>
            {workflowSummaries.map(({id: workflowId, name, humanId, editURL}, i) => (
              <span key={workflowId}>
                {i > 0 && ', '}
                <a
                  onClick={() => {
                    WorkflowActions.routeToWorkflow(workflowId);
                  }}
                >{`${humanId} \u2022 ${name}`}</a>
              </span>
            ))}
          </div>
        </div>
      )}
      {entrySummaries.length > 0 && (
        <div className="u-spacing-top">
          <Headers.Title>Entries</Headers.Title>
          <div>
            {entrySummaries.map(({id: entryId, name}, i) => (
              <span key={entryId}>
                {i > 0 && ', '}
                <a
                  onClick={() => {
                    FileBrowserActions.openFile(entryId);
                  }}
                >
                  {name}
                </a>
              </span>
            ))}
          </div>
        </div>
      )}
    </div>
  );
}
FulfillmentLinks.propTypes = {
  entrySummaries: PropTypes.arrayOf(PropTypes.object.isRequired),
  workflowSummaries: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      humanId: PropTypes.string.isRequired,
      name: PropTypes.string.isRequired,
      editURL: PropTypes.string,
    }).isRequired
  ),
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
} as any;

export function mapStateToProps(state: BenchlingState, {requestId}: {requestId: string}): ConnectedProps {
  const workflowSelector = new WorkflowSelector(state.models.workflows);
  const workflowSummariesById = _.indexBy(workflowSelector.getAllWorkflowSummaries()!, 'id');
  const {fulfillmentsById, fulfillmentIdsByRequestId} = state.models.requests.fulfillments;
  const {entrySummariesById} = state.models;

  const fulfillments = fulfillmentIdsByRequestId[requestId].map((id) => fulfillmentsById[id]);
  // eslint-disable-next-line no-restricted-syntax
  const entryIds = _.uniq(_.compact(_.pluck(fulfillments, 'entryId')));
  // eslint-disable-next-line no-restricted-syntax
  const workflowIds = _.uniq(_.compact(_.pluck(fulfillments, 'workflowId')));

  if (
    entryIds.some((id) => entrySummariesById[id] == null) ||
    workflowIds.some((id) => workflowSummariesById[id] == null)
  ) {
    return {entrySummaries: null, workflowSummaries: null};
  }

  return {
    entrySummaries: entryIds.map((entryId) => entrySummariesById[entryId]),
    workflowSummaries: workflowIds.map((workflowId) => workflowSummariesById[workflowId]),
  };
}

export default connect(mapStateToProps)(FulfillmentLinks);
